
export const AuthActionTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_TOKEN: 'SET_TOKEN',
  SET_PRIVILEGE: 'SET_PRIVILEGE',
  SET_PAGE_BEFORE_LOGIN: 'SET_PAGE_BEFORE_LOGIN',
  SET_LOGOUT_STATE: 'SET_LOGOUT_STATE'
};